import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import '../css/feedback.css';

import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';

const Feedback = ({ data }) => {
  const [isPlaying, setIsPlaying] = useState(-1);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handlePlayVideo = (index) => {
    setIsPlaying(index);
    if (swiperInstance) {
      swiperInstance.autoplay.stop();
    }
  };

  const handleCloseVideo = () => {
    setIsPlaying(-1);
    if (swiperInstance) {
      swiperInstance.autoplay.start();
    }
  };

  const slides = (() => {
    if (!data || data.length === 0) return [];

    const cloned = [...data];
    while (cloned.length < 8) {
      cloned.push(...data);
    }
    return cloned.slice(0, 8);
  })();

  return (
    <section className="feedback testimonials mb-md-5">
      <div className="container">
        <h2 className="text-center default-box-title m-0">
          Cảm nhận của Khách hàng
        </h2>
        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          freeMode={true}
          loop={true}
          spaceBetween={0}
          loopAdditionalSlides={2}
          coverflowEffect={{
            rotate: 25,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={{ clickable: true }}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          className="gird-swiper"
          onSwiper={setSwiperInstance}
        >
          {slides.map((content, index) => (
            <SwiperSlide key={index}>
              {isPlaying !== index ? (
                <div
                  className="box-swiper"
                  style={{
                    backgroundImage: `url("${content.imageUrl}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                  onClick={() => handlePlayVideo(index)}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      background: 'rgba(0, 0, 0, 0.6)',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src="/images/icons/play.png"
                      alt="Play icon"
                      loading="lazy"
                      style={{
                        width: '50px',
                        height: '50px',
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div style={{ position: 'relative' }}>
                  <iframe
                    className="box-swiper"
                    src={content.videoUrl}
                    title={content.title}
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  />
                  <button
                    onClick={handleCloseVideo}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'red',
                      color: '#fff',
                      border: 'none',
                      padding: '5px 10px',
                      cursor: 'pointer',
                      borderRadius: '5px',
                    }}
                  >
                    Đóng Video
                  </button>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Feedback;
